export default {
  image: 'A4_12_2.png',
  pdf: '220815_WA-MIWO_016_A4_12_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-016',
    technicalValues: {
      soundReductionIndex: {
        output: '54,8',
        value: 54.8
      },
      heatTransferCoefficient: {
        output: '0,15',
        value: 0.15
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 90-B',
        value: 'F-90-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 16',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Steinwolleplatte 2/B/H4 W5',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'mst-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/200',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-200'
        },
        {
          output: '200 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-200'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'ip-15'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '311,5',
        value: 311.5
      }
    }
  }
}
